<script>
    import { onDestroy } from 'svelte';
    import Button from 'views/components/button/Button.svelte';
    import Spinner from 'views/components/spinner/Spinner.svelte'
    import Icon from 'views/components/icon/Icon.svelte'
    import {SvelteMap} from 'svelte/reactivity';

    const { simpleMode = false } = $props()

    let isLoading = $state(true)
    let hasLoadingFailed = $state(false)
    let math

    let textareaElement
    let outputElement = $state()
    let shiftIsActive = $state(false)

    let cursorPosition = $state(0)
    let inputTokens = $state([])

    let answer = null
    let visibleOutput = $state('')

    const hasVisibleInput = $derived(inputTokens.length > 0)

    const sessionStorageId = `calculator:${Backbone.Model.user.id}`;

    const buttons = $derived.by(() => {
        if (simpleMode) {
            return [{
                label: '(',
                command: '('
            }, {
                label: ')',
                command: ')'
            }, {
                label: '%',
                command: 'percent'
            }, {
                icon: 'arrow-left',
                command: 'left'
            }, {
                icon: 'arrow-right',
                command: 'right'
            }, {
                label: '7',
                style: 'blue-black',
                command: '7'
            }, {
                label: '8',
                style: 'blue-black',
                command: '8'
            }, {
                label: '9',
                style: 'blue-black',
                command: '9'
            }, {
                label: '⌫',
                style: 'red',
                command: 'backspace'
            }, {
                label: 'C',
                style: 'red',
                command: 'clear'
            }, {
                label: '4',
                style: 'blue-black',
                command: '4'
            }, {
                label: '5',
                style: 'blue-black',
                command: '5'
            }, {
                label: '6',
                style: 'blue-black',
                command: '6'
            }, {
                label: '×',
                style: 'large-font',
                command: 'multiply'
            }, {
                label: '÷',
                style: 'large-font',
                command: 'divide'
            }, {
                label: '1',
                style: 'blue-black',
                command: '1'
            }, {
                label: '2',
                style: 'blue-black',
                command: '2'
            }, {
                label: '3',
                style: 'blue-black',
                command: '3'
            }, {
                label: '+',
                style: 'large-font',
                command: 'add'
            }, {
                label: '-',
                style: 'large-font',
                command: 'subtract'
            }, {
                label: '0',
                style: 'blue-black',
                command: '0'
            }, {
                label: ',',
                command: 'decimal'
            }, {
                label: '⁺ ⁄ ₋',
                style: 'large-font',
                command: 'toggleSign',
            }, {
                icon: 'copy',
                command: 'copy-calculation',
                title: window.i18n.gettext('Copy calculation'),
                disabled: !hasVisibleInput,
            }, {
                label: '=',
                style: 'blue-black large-font',
                command: 'execute',
            }]
        }

        return [{
            label: 'shift',
            style: 'blue',
            command: 'shift'
        }, {
        }, {
        }, {
            icon: 'copy',
            command: 'copy-calculation',
            title: window.i18n.gettext('Copy calculation'),
            disabled: !hasVisibleInput,
        }, {
            icon: 'arrow-left',
            command: 'left'
        }, {
            icon: 'arrow-right',
            command: 'right'
        }, {
            label: 'sin',
            command: 'sin',
            shift: {
                label: 'sin<sup>-1</sup>',
                style: 'blue',
                command: 'asin'
            }
        }, {
            label: 'cos',
            command: 'cos',
            shift: {
                label: 'cos<sup>-1</sup>',
                style: 'blue',
                command: 'acos'
            }
        }, {
            label: 'tan',
            command: 'tan',
            shift: {
                label: 'tan<sup>-1</sup>',
                style: 'blue',
                command: 'atan'
            }
        }, {
            label: 'log',
            command: 'log'
        }, {
            label: 'ln',
            command: 'ln'
        }, {
            label: 'e',
            command: 'e'
        }, {
            label: 'π',
            command: 'pi'
        }, {
            label: '√',
            command: 'sqrt'
        }, {
            label: 'x<sup>2</sup>',
            command: 'square'
        }, {
            label: 'x<sup>y</sup>',
            command: 'exponent'
        }, {
            label: '(',
            command: '('
        }, {
            label: ')',
            command: ')'
        }, {
            label: '7',
            style: 'blue-black',
            command: '7'
        }, {
            label: '8',
            style: 'blue-black',
            command: '8'
        }, {
            label: '9',
            style: 'blue-black',
            command: '9'
        }, {
            label: '⌫',
            style: 'red',
            command: 'backspace'
        }, {
            label: 'C',
            style: 'red',
            command: 'clear'
        }, {
            label: '4',
            style: 'blue-black',
            command: '4'
        }, {
            label: '5',
            style: 'blue-black',
            command: '5'
        }, {
            label: '6',
            style: 'blue-black',
            command: '6'
        }, {
            label: '×',
            style: 'large-font',
            command: 'multiply'
        }, {
            label: '÷',
            style: 'large-font',
            command: 'divide'
        }, {
            label: '1',
            style: 'blue-black',
            command: '1'
        }, {
            label: '2',
            style: 'blue-black',
            command: '2'
        }, {
            label: '3',
            style: 'blue-black',
            command: '3'
        }, {
            label: '+',
            style: 'large-font',
            command: 'add'
        }, {
            label: '-',
            style: 'large-font',
            command: 'subtract'
        }, {
            label: '0',
            style: 'blue-black',
            command: '0'
        }, {
            label: ',',
            command: 'decimal'
        }, {
            label: '×10<sup>x</sup>',
            command: 'alog'
        }, {
            label: 'ans',
            command: 'answer'
        }, {
            label: '=',
            style: 'blue-black large-font',
            command: 'execute'
        }]
    })

    const tokens = new Map([
        [ 'multiply', { display: '×', expression: '*' }],
        [ 'divide', { display: '÷', expression: '/' }],
        [ 'add', { display: '+', expression: '+' }],
        [ 'subtract', { display: '-', expression: '-' }],
        [ 'decimal', { display: ',', expression: '.' }],
        [ '0', { display: '0', expression: '0' }],
        [ '1', { display: '1', expression: '1' }],
        [ '2', { display: '2', expression: '2' }],
        [ '3', { display: '3', expression: '3' }],
        [ '4', { display: '4', expression: '4' }],
        [ '5', { display: '5', expression: '5' }],
        [ '6', { display: '6', expression: '6' }],
        [ '7', { display: '7', expression: '7' }],
        [ '8', { display: '8', expression: '8' }],
        [ '9', { display: '9', expression: '9' }],
        [ '(', { display: '(', expression: '(' }],
        [ ')', { display: ')', expression: ')' }],
        [ 'sin', { display: 'sin(', expression: 'sinDegrees(' }],
        [ 'asin', { display: 'sin<sup>-1</sup>(', expression: 'asinDegrees(', textDisplay: 'sin⁻¹(' }],
        [ 'cos', { display: 'cos(', expression: 'cosDegrees(' }],
        [ 'acos', { display: 'cos<sup>-1</sup>(', expression: 'acosDegrees(', textDisplay: 'cos⁻¹(' }],
        [ 'tan', { display: 'tan(', expression: 'tanDegrees(' }],
        [ 'atan', { display: 'tan<sup>-1</sup>(', expression: 'atanDegrees(', textDisplay: 'tan⁻¹(' }],
        // Insert space after 'pi ' so it cannot be concatenated into a function or
        // constant name that doesn't exist. For example: 'pi cos(', not 'picos('.
        [ 'pi', { display: 'π', expression: 'pi ' }],
        [ 'sqrt', { display: '√(', expression: 'sqrt(' }],
        [ 'square', { display: '<sup>2</sup>', expression: '^2', textDisplay: '²' }],
        [ 'ln', { display: 'ln(', expression: 'log(' }],
        [ 'e', { display: 'e', expression: 'e ' }],
        [ 'log', { display: 'log(', expression: 'log10(' }],
        [ 'exponent', { display: '^', expression: '^' }],
        [ 'alog', { display: '×10^', expression: '*10^' }],
        [ 'answer', { display: 'ans', expression: 'answer' }],
        [ 'percent', { display: '%', expression: '%' } ],
        [ 'toggleSign', { display: '(-', expression: '(-' }],
    ])

    const keyToCommand = new SvelteMap([
        ['*', 'multiply'],
        ['/', 'divide'],
        ['+', 'add'],
        ['-', 'subtract'],
        [',', 'decimal'],
        ['^', 'exponent'],
        ['±', 'toggleSign'],
        ['Enter', 'execute'],
        ['=', 'execute'],
        ['Backspace', 'backspace'],
        ['Delete', 'delete'],
        ['ArrowLeft', 'left'],
        ['ArrowRight', 'right'],
        ['0', '0'],
        ['1', '1'],
        ['2', '2'],
        ['3', '3'],
        ['4', '4'],
        ['5', '5'],
        ['6', '6'],
        ['7', '7'],
        ['8', '8'],
        ['9', '9'],
        ['(', '('],
        [')', ')'],
        ['%', 'percent'],
    ])

    // Remove keyboard shortcuts for commands that don't have a button.
    keyToCommand.forEach((command, keyboardKey) => {
        if (!buttons.some((button) => button.command === command)) {
            keyToCommand.delete(keyboardKey)
        }
    })

    const previousAnswerOperators = $derived.by(() => {
        if (simpleMode) {
            return ['multiply', 'divide', 'add', 'subtract']
        }
        return ['multiply', 'divide', 'add']
    })

    initialize()

    async function initialize() {
        try {
            isLoading = true
            hasLoadingFailed = false

            // We use all because we need to parse expressions. Use /number to reduce bundle size.
            const { create, all } = await import(
                /* rspackChunkName: "mathjs" */
                'mathjs/number'
            )
            math = create(all, {})

            // Define custom sin, cos and tan because we need degrees instead of radians
            math.import({
                sinDegrees: (degrees) => {
                    return math.evaluate('sin(' + degrees + ' * pi / 180)')
                },
                asinDegrees: (ratio) => {
                    return math.evaluate('asin(' + ratio + ') * 180 / pi')
                },
                cosDegrees: (degrees) => {
                    return math.evaluate('cos(' + degrees + ' * pi / 180)')
                },
                acosDegrees: (ratio) => {
                    return math.evaluate('acos(' + ratio + ') * 180 / pi')
                },
                tanDegrees: (degrees) => {
                    return math.evaluate('tan(' + degrees + ' * pi / 180)')
                },
                atanDegrees: (ratio) => {
                    return math.evaluate('atan(' + ratio + ') * 180 / pi')
                },
            })

            restoreState()
            isLoading = false
        } catch {
            isLoading = false
            hasLoadingFailed = true
        }
    }

    // Save state on destroy, so it can be restored later
    onDestroy(() => {
        if (isLoading || hasLoadingFailed) {
            return
        }

        const state = { inputTokens, answer, visibleOutput }
        window.sessionStorage.setItem(sessionStorageId, JSON.stringify(state))
    })

    function restoreState() {
        let state
        try {
            state = JSON.parse(window.sessionStorage.getItem(sessionStorageId))
        } catch {
            return
        }

        if (!state) {
            return
        }

        inputTokens = state.inputTokens
        cursorPosition = state.inputTokens.length
        answer = state.answer
        visibleOutput = state.visibleOutput
    }

    function onClickButton(command) {

        // If shift is on, turn it off after a command
        if (shiftIsActive && command !== 'shift') {
            shiftIsActive = false
        }

        // Handle execute first, so that we can repeat the previous input (useful with ans)
        if (command === 'execute') {
            try {
                const expression = getExpression()

                // Do nothing if expression is empty (prevent error)
                if (expression === '') {
                    return
                }

                // We pass answer so that the ans button can continue on the previous answer
                const evaluation = math.evaluate(expression, { answer })

                // Math.js can give NaN or Infinity as a result, handle it as an error
                if (!Number.isFinite(evaluation)) {
                    throw new Error('Not finite')
                }
                answer = evaluation

                // Use 10 digits for the answer and prevent scientific notation (1e+10) if possible
                const roundedEvaluation = math.evaluate('round(' + answer + ', 14)')

                if (simpleMode) {
                    // For simple mode, avoid exponents and use digit grouping separators.
                    visibleOutput = roundedEvaluation.toLocaleString(
                        window.app_version.language,
                        {
                            maximumFractionDigits: 10,
                        }
                    )
                } else {
                    visibleOutput = math.format(
                        roundedEvaluation,
                        {
                            precision: 10,
                            lowerExp: -8,
                            upperExp: 10,
                        }
                    ).replace('.', ',')
                }

                cursorPosition = null
            } catch {
                visibleOutput = window.i18n.gettext('ERROR')
            }
            return
        }

        if (command === 'copy-calculation') {
            navigator.clipboard.writeText(getCopiableContent()).then(() => {
                Backbone.View.layout.openStatus(
                    window.i18n.gettext('Calculation has been copied'),
                    'info'
                )
            })
            return
        }

        // If there is no cursor, reset the screen and then handle the command
        if (cursorPosition === null) {
            inputTokens = []
            visibleOutput = ''
            cursorPosition = 0
        }

        // Handle special commands that do not input a new character
        switch (command) {
            case 'clear':
                inputTokens = []
                cursorPosition = 0
                visibleOutput = ''
                return
            case 'shift':
                shiftIsActive = !shiftIsActive
                return
            case 'backspace':
                if (cursorPosition > 0) {
                    inputTokens.splice(cursorPosition - 1, 1)
                    cursorPosition = cursorPosition - 1
                }
                return
            case 'delete':
                if (cursorPosition < inputTokens.length) {
                    inputTokens.splice(cursorPosition, 1)
                    inputTokens = inputTokens
                }
                return
            case 'left':
                if (cursorPosition > 0) {
                    cursorPosition = cursorPosition - 1
                }
                return
            case 'right':
                if (cursorPosition < inputTokens.length) {
                    cursorPosition = cursorPosition + 1
                }
                return
            case 'toggleSign': {
                if (inputTokens.length === 0) {
                    if (Number.isFinite(answer)) {
                        inputTokens.push(
                            tokens.get('toggleSign'),
                            tokens.get('answer'),
                            tokens.get(')')
                        )
                        cursorPosition = 3
                    }
                    return
                }

                // Find tokens that correspond to the last constant in the current expression.
                let constantEndIndex = inputTokens.length - 1
                // Do nothing if last token is not a digit, bracket or exponent.
                if (
                    !isConstantToken(inputTokens[constantEndIndex]) &&
                    !isKnownToken('(', inputTokens[constantEndIndex]) &&
                    !isKnownToken(')', inputTokens[constantEndIndex]) &&
                    !isKnownToken('exponent', inputTokens[constantEndIndex]) &&
                    !isKnownToken('percent', inputTokens[constantEndIndex])
                ) {
                    return
                }
                while (constantEndIndex >= 0 && !isConstantToken(inputTokens[constantEndIndex])) {
                    constantEndIndex--
                }
                if (constantEndIndex < 0) {
                    return
                }
                let constantStartIndex = constantEndIndex
                while (constantStartIndex > 0 && isConstantToken(inputTokens[constantStartIndex - 1])) {
                    constantStartIndex--
                }
                const tokenBefore = constantStartIndex > 0 ? inputTokens[constantStartIndex - 1] : null

                // If operator before last constant is a subtract operator, replace it with a addition operator.
                // Otherwise, toggle wrapping the last constant with `(-constant)`.
                if (isKnownToken('subtract', tokenBefore)) {
                    inputTokens[constantStartIndex - 1] = tokens.get('add')
                } else if (isKnownToken('toggleSign', tokenBefore)) {
                    inputTokens.splice(constantStartIndex - 1, 1)
                    if (isKnownToken(')', inputTokens[constantEndIndex])) {
                        inputTokens.splice(constantEndIndex, 1)
                    }
                } else {
                    inputTokens.splice(constantStartIndex, 0, tokens.get('toggleSign'))
                    inputTokens.splice(constantEndIndex + 2, 0, tokens.get(')'))
                }

                cursorPosition = inputTokens.length
                inputTokens = inputTokens
                return
            }
        }

        // Handle regular commands, find the token and insert it at the cursor position
        const token = tokens.get(command)
        if (!token) {
            return
        }

        // For convenience, prepend 'ans' for some operations
        if (inputTokens.length === 0 && Number.isFinite(answer) && previousAnswerOperators.includes(command)) {
            inputTokens.push(tokens.get('answer'))
            cursorPosition = cursorPosition + 1
        }

        inputTokens.splice(cursorPosition, 0, token)
        cursorPosition = cursorPosition + 1
    }

    function getVisibleInput() {
        let visibleInput = ''

        for (const [index, token] of inputTokens.entries()) {
            if (cursorPosition === index) {
                visibleInput += '<span class="cursor"></span>'
            }
            visibleInput += token.display
        }

        if (cursorPosition === inputTokens.length) {
            visibleInput += '<span class="cursor"></span>'
        }

        return visibleInput
    }

    function getCopiableContent() {
        let content = ''
        for (const token of inputTokens) {
            content += token.textDisplay ?? token.display
        }
        if (visibleOutput && visibleOutput !== window.i18n.gettext('ERROR')) {
            content += '\n' + visibleOutput
        }
        return content
    }

    function getExpression() {
        let expression = ''
        for (const token of inputTokens) {
            expression = expression + token.expression
        }

        // Math.js does not auto close parenthesis, so we do it here
        // sin(sqrt(4 becomes sin(sqrt(4))
        const countOpen = expression.split('(').length - 1
        const countClose = expression.split(')').length - 1
        if (countOpen > countClose) {
            expression = expression + ')'.repeat(countOpen - countClose)
        }

        return expression
    }

    function isConstantToken(token) {
        return (
            /^[\d\.]$/.test(token.expression) ||
            isKnownToken('pi', token) ||
            isKnownToken('e', token) ||
            isKnownToken('answer', token)
        )
    }

    function isKnownToken(key, otherToken) {
        if (otherToken) {
            const knownToken = tokens.get(key)
            if (knownToken) {
                return knownToken.expression === otherToken.expression
            }
        }
        return false
    }

    function setupTextarea(element) {
        textareaElement = element
        textareaElement.focus()
    }

    function onClickCalculator(event) {
        if (event.target === outputElement) {
            return
        }
        textareaElement.focus()
    }

    function keyDown(event) {
        const command = keyToCommand.get(event.key)
        if (!command) {
            return
        }

        onClickButton(command)
    }
</script>

{#snippet buttonLabel(buttonData)}
    {#if buttonData.icon}
        <Icon name={buttonData.icon}></Icon>
    {:else if buttonData.label}
        <!-- eslint-disable-next-line svelte/no-at-html-tags -->
        {@html buttonData.label}
    {/if}
{/snippet}

{#if isLoading}
    <div class="loading">
        <Spinner></Spinner>
    </div>
{:else if hasLoadingFailed}
    <div class="failed">
        {window.i18n.gettext('Loading failed')}
        <Button label={window.i18n.gettext('Try again')} callback={initialize} icon="refresh"></Button>
    </div>
{:else}
    <!-- svelte-ignore a11y_click_events_have_key_events -->
    <!-- svelte-ignore a11y_no_static_element_interactions -->
    <div
        class="calculator"
        onclick={onClickCalculator}>
        <div class="screen">
            <textarea
                class="textarea"
                use:setupTextarea
                onkeydown={keyDown}
                inputmode="none"></textarea>
            <div class="input-scroll">
                <div class="input">
                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                    {@html getVisibleInput()}
                </div>
            </div>
            <div class="output" bind:this={outputElement}>{visibleOutput}</div>
        </div>
        <div class="buttons">
            {#each buttons as button (buttons.indexOf(button))}
                <div
                    class="button-container"
                    class:simple-mode={simpleMode}
                    class:button-container--double-width={button.doubleWidth}
                >
                    {#if button.label || button.icon}
                        {#if button.shift}
                            <div class="shift">
                                {#if shiftIsActive}
                                    <!-- eslint-disable-next-line svelte/no-at-html-tags -->
                                    {@html '&nbsp;'}
                                {:else}
                                    {@render buttonLabel(button.shift)}
                                {/if}
                            </div>
                        {/if}
                        <button
                            class={shiftIsActive && button.shift ? button.shift.style : button.style}
                            onclick={() => {
                                onClickButton(shiftIsActive && button.shift ? button.shift.command : button.command)
                            }}
                            title={button.title}
                            disabled={button.disabled}
                        >
                            {#if shiftIsActive && button.shift}
                                {@render buttonLabel(button.shift)}
                            {:else}
                                {@render buttonLabel(button)}
                            {/if}
                        </button>
                    {/if}
                </div>
            {/each}
        </div>
    </div>
{/if}

<style lang="scss">/*
* Scut, a collection of Sass utilities
* to ease and improve our implementations of common style-code patterns.
* v1.0.1
* Docs at http://davidtheclark.github.io/scut
*/
/* TODO implement tooltip arrow */
.loading {
  max-width: 48px;
  margin: 16px auto;
}

.failed {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  margin-top: 16px;
}

.calculator {
  width: 320px;
  margin: 0;
  padding: 16px;
  border: none;
}
.calculator .screen {
  padding: 16px;
  border-radius: 4px;
  background: rgba(0, 0, 0, 0.1);
  border: 1px solid rgba(0, 0, 0, 0.25);
  overflow: hidden;
}
.calculator .screen .textarea {
  position: absolute;
  width: 0;
  height: 0;
  transform: scale(0);
}
.calculator .screen .input-scroll {
  direction: rtl;
  text-align: left;
}
.calculator .screen .input-scroll .input {
  display: inline-block;
  direction: ltr;
}
.calculator .screen .input,
.calculator .screen .output {
  font-size: 20px;
  line-height: 24px;
  min-height: 24px;
  font-weight: 400;
  letter-spacing: 1px;
}
.calculator .screen .input :global(.cursor) {
  border-right: 1px solid currentColor;
  margin-right: -1px;
  animation: blink 1s infinite;
}
@keyframes blink {
  50% {
    border-color: transparent;
  }
}
.calculator .screen .output {
  margin-top: 16px;
  text-align: right;
}
.calculator .buttons {
  display: grid;
  grid-template-columns: repeat(30, 1fr);
  gap: 8px;
  margin-top: 20px;
}
.calculator .buttons .button-container {
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  grid-column: span 6;
}
.calculator .buttons .button-container:not(.simple-mode):nth-child(-n+18) {
  grid-column: span 5;
}
.calculator .buttons .button-container--double-width {
  grid-column: span 12;
}
.calculator .buttons .button-container .shift {
  margin-bottom: 2px;
  text-align: right;
  font-size: 12px;
  color: hsl(205, 60%, 44%);
}
.calculator .buttons .button-container .shift:has(> :global(svg)) {
  text-align: center;
}
.calculator .buttons .button-container .shift > :global(svg) {
  fill: currentColor;
  height: 1em;
}
.calculator .buttons .button-container button {
  height: 36px;
  border-radius: 4px;
  text-align: center;
  font-size: 16px;
  background: hsl(27, 15%, 93%);
  border: 1px solid hsl(40, 4%, 84%);
}
.calculator .buttons .button-container button > :global(svg) {
  fill: currentColor;
  height: 1.2em;
  vertical-align: middle;
}
.calculator .buttons .button-container button:active {
  transform: scale(0.95);
}
.calculator .buttons .button-container button.blue-black {
  background: #122d40;
  color: #fff;
  border-color: transparent;
}
.calculator .buttons .button-container button.blue {
  background: rgba(44.88, 123.42, 179.52, 0.1);
  color: hsl(205, 60%, 44%);
  border-color: rgba(0, 0, 0, 0.1);
}
.calculator .buttons .button-container button.red {
  color: #fb455b;
}
.calculator .buttons .button-container button.large-font {
  font-size: 20px;
}
.calculator .buttons .button-container button:disabled {
  cursor: not-allowed;
  opacity: 0.5;
}</style>
